export default __webpack_public_path__ + "static/media/ic_sort_bottom_selected.2a871641.svg";